module.exports = __webpack_public_path__ + "img/30600.fbb1854b.jpg";